/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPrebid } from '../fn/prebid/create-prebid';
import { CreatePrebid$Params } from '../fn/prebid/create-prebid';
import { deletePrebid } from '../fn/prebid/delete-prebid';
import { DeletePrebid$Params } from '../fn/prebid/delete-prebid';
import { findPrebidsByLotId } from '../fn/prebid/find-prebids-by-lot-id';
import { FindPrebidsByLotId$Params } from '../fn/prebid/find-prebids-by-lot-id';
import { patchPrebid } from '../fn/prebid/patch-prebid';
import { PatchPrebid$Params } from '../fn/prebid/patch-prebid';
import { patchPrebids } from '../fn/prebid/patch-prebids';
import { PatchPrebids$Params } from '../fn/prebid/patch-prebids';
import { PrebidDto } from '../models/prebid-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedPrebidService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findPrebidsByLotId()` */
  static readonly FindPrebidsByLotIdPath = '/api/prebids';

  /**
   * Finds own prebids by lot-id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findPrebidsByLotId()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrebidsByLotId$Response(params: FindPrebidsByLotId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrebidDto>>> {
    return findPrebidsByLotId(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds own prebids by lot-id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findPrebidsByLotId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrebidsByLotId(params: FindPrebidsByLotId$Params, context?: HttpContext): Observable<Array<PrebidDto>> {
    return this.findPrebidsByLotId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PrebidDto>>): Array<PrebidDto> => r.body)
    );
  }

  /** Path part for operation `createPrebid()` */
  static readonly CreatePrebidPath = '/api/prebids';

  /**
   * Submits a new prebid.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPrebid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPrebid$Response(params: CreatePrebid$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidDto>> {
    return createPrebid(this.http, this.rootUrl, params, context);
  }

  /**
   * Submits a new prebid.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPrebid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPrebid(params: CreatePrebid$Params, context?: HttpContext): Observable<PrebidDto> {
    return this.createPrebid$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidDto>): PrebidDto => r.body)
    );
  }

  /** Path part for operation `patchPrebids()` */
  static readonly PatchPrebidsPath = '/api/prebids';

  /**
   * Updates existing prebids and returns the changed ones.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchPrebids()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchPrebids$Response(params: PatchPrebids$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrebidDto>>> {
    return patchPrebids(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates existing prebids and returns the changed ones.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchPrebids$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchPrebids(params: PatchPrebids$Params, context?: HttpContext): Observable<Array<PrebidDto>> {
    return this.patchPrebids$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PrebidDto>>): Array<PrebidDto> => r.body)
    );
  }

  /** Path part for operation `deletePrebid()` */
  static readonly DeletePrebidPath = '/api/prebids/{id}';

  /**
   * Requests a withdraws for an existing prebid.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePrebid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deletePrebid$Response(params: DeletePrebid$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidDto>> {
    return deletePrebid(this.http, this.rootUrl, params, context);
  }

  /**
   * Requests a withdraws for an existing prebid.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePrebid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deletePrebid(params: DeletePrebid$Params, context?: HttpContext): Observable<PrebidDto> {
    return this.deletePrebid$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidDto>): PrebidDto => r.body)
    );
  }

  /** Path part for operation `patchPrebid()` */
  static readonly PatchPrebidPath = '/api/prebids/{id}';

  /**
   * Updates an existing prebid and returns the changed one(s).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchPrebid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchPrebid$Response(params: PatchPrebid$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrebidDto>>> {
    return patchPrebid(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing prebid and returns the changed one(s).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchPrebid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchPrebid(params: PatchPrebid$Params, context?: HttpContext): Observable<Array<PrebidDto>> {
    return this.patchPrebid$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PrebidDto>>): Array<PrebidDto> => r.body)
    );
  }

}
